
import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

export default function ChannelDropDown(props) {
  const { control } = useForm();

  const handleChannelChange = (e) => {
    const selectedChannel = e.target.value;
    if (selectedChannel === "ALL") {
      props.handleChannelFilter('channel',null);
    } else {
      props.handleChannelFilter('channel', selectedChannel);
    }
  };
  
  return (
    <div>
      <p style={{marginBottom:"2px", fontSize:"14px",color:'#808080'}}>Filter by Channel</p>
      <form>
        <Controller 
          name='channel'
          control={control} 
          render={({ field }) => (
            <Select 
              label='Select Channel'
              defaultValue={"ALL"}
              onChange={handleChannelChange}
              sx={{ width: '200px', borderRadius: '0px', border: '1px solid #000', height: '40px'}}
            >
              <MenuItem  value={"ALL"}>ALL</MenuItem>
              {props.channelData.map((item) => (
                <MenuItem key={item._id} value={item._id}>{item.name}</MenuItem>
              ))}
            </Select>
          )}
          type='number'
        />
      </form>
    </div>
  );
}

